import styled from 'styled-components';

export const addCashWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 23px 20px 20px;
  box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    border-radius: 0;
    padding: 10px 16px 20px 16px;
    box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
  }
`;

export const Heading = styled.p`
  font-size: 24px;
  font-weight: 900;
  color: #000;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  & .rupeeYellowIcon {
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 20px;
  }
`;

export const AddCashTextWrap = styled.span`
  margin-left: 10px;
`;

export const RgtsWrap = styled.div`
  flex: 1;
  padding: 26px 20px;
  border: solid 1px #e7f0ff;
  background-color: #f1f6fd;
  position: relative;
  border-radius: 4px;
  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RecTag = styled.span`
  height: 18px;
  flex-grow: 0;
  padding: 3px 10px;
  background-image: linear-gradient(83deg, #c86dd7, #3023ae 100%);
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  text-transform: uppercase;
  border-radius: 10px;
  position: absolute;
  top: -9px;
`;

export const Details = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Title = styled.p`
  color: #4a4a4a;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 2px;
`;
export const NoExtra = styled.p`
  color: #4a4a4a;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 8px;
  span {
    color: #198b7d;
  }
`;

export const Text = styled.p`
  font-size: 12px;
  line-height: 18px;
  color: #4a4a4a;
  margin-bottom: 8px;
`;

export const NoteText = styled.p`
  font-size: 15px;
  line-height: 18px;
  color: #4a4a4a;
  margin-bottom: 8px;
`;

export const ViewDtls = styled.a`
  font-weight: 900;
  font-size: 14px;
  color: #008cff;
  cursor: pointer;
  text-decoration: none;
  @media (max-width: 768px) {
    margin-left: unset;
    margin-top: 16px;
  }
`;

export const Rtgspop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  margin: auto;
  width: 483px;
  height: 482px;
  flex-grow: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 10px;

  @media (max-width: 768px) {
    width: calc(100% - 32px);
    height: 503px;
  }

  & table {
    border: none;
  }
  & tr td {
    padding: 0 0 10px;
    font-size: 14px;
    color: #4a4a4a;
  }

  & tr td:last-of-type {
    font-weight: 900;
  }
`;

export const Cross = styled.span`
  content: '';
  width: 24px;
  height: 24px;
  background: #fff;
  color: #000;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 1;
  border-radius: 100%;
  cursor: pointer;

  @media (max-width: 768px) {
    top: -30px;
    right: 0px;
  }

  &::after {
    content: '';
    width: 1px;
    height: 16px;
    background: #000;
    transform: rotate(45deg);
    display: flex;
    position: absolute;
    top: 4px;
    left: 11px;
  }

  &::before {
    content: '';
    width: 1px;
    height: 16px;
    background: #000;
    transform: rotate(-45deg);
    display: flex;
    position: absolute;
    top: 4px;
    left: 11px;
  }
`;

export const BackDrop = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
`;

export const Or = styled.p`
  margin: 0 5px;
  font-size: 12px;
  line-height: 24px;
  font-weight: 700;
  align-self: center;
  flex-shrink: 0;
  color: #000;
  @media (max-width: 768px) {
    font-size: 16px;
    margin: 16px 0 24px 0;
  }
`;

export const Recharge = styled.div`
  display: flex;
  width: 468px;
  flex-shrink: 0;
  flex-direction: column;
  padding: 16px 37px 16px 16px;
  background-color: #f8f8f8;
  display: flex;
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 16px;
    width: 100%;
  }

  & input {
    width: 300px;
    border: none;
    border-bottom: solid 1px #ccc;
    padding: 0px 0px 5px 0;
    background: transparent;
    outline: none;
    font-size: 20px;
    font-weight: 900;
    color: #000;
  }
`;

export const RegTitle = styled.p`
  color: #000;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 20px;
  font-weight: 700;
`;

export const RegHeading = styled.p`
  color: #4a4a4a;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;
`;

export const RegAmount = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PriceList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop}
  `}
  ${p =>
    p.marginBottom &&
    `
    margin-bottom: ${p.marginBottom}
  `}
`;
export const PriceListItem = styled.li`
  display: inline-flex;
  background: #ffffff;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 24px;
  color: #4a4a4a;
  cursor: pointer;
  position: relative;
  min-width: 90px;
  ${p =>
    p.selected &&
    `
    background: #338EFA;
    color: #fff;
    font-weight: 700;
    box-shadow: none;
  `}
  @media (max-width: 768px) {
    padding: 8px 13px;
    font-size: 12px;
    line-height: 15px;
  }
`;
export const PriceTag = styled.span(
  props => `
  display: inline-flex;
  background: linear-gradient(67.62deg, #43E1A8 0%, #219393 58.33%);
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  height: 15px;
  padding: 0 6px;
  font-size: 10px;
  line-height: 10px;
  color: #fff;
  font-weight: 700;
  position: absolute;
  left: 6px;
  top: -9px;

  @media (max-width: 768px) {
    font-size: 8px;
  }
  &.font9 {
    font-size: 9px;
  }
  &.width100 {
   width: 100px !important;
  }
  &.width90{
    width: 90px;
  }
`,
);

export const PopTitle = styled.p`
  color: #141823;
  font-size: 20px;
  font-weight: 900;
  padding: 20px 30px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.5);
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  @media (max-width: 768px) {
    padding: 16px;
  }

  & p {
    font-size: 14px;
    line-height: 18px;
    color: #4a4a4a;
    margin-bottom: 20px;
  }
`;

export const Copy = styled.a`
  margin: 42px auto 0;
  font-size: 16px;
  font-weight: 900;
`;

export const New = styled.span`
  width: 35px;
  height: 15px;
  padding: 2px 5.5px 3px;
  border-radius: 10px;
  background-image: linear-gradient(67deg, #43e1a8 34%, #219393 134%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 10px;
  text-transform: uppercase;
  margin-left: 4px;
`;

export const AddCashBody = styled.div`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const AddCashBodyRight = styled.div`
  flex: 1;
  flex-shrink: 0;
`;
export const SmallText = styled.p`
  font-size: 12px;
  line-height: 18px;
  color: #9b9b9b;
  margin-bottom: 16px;
`;
export const InputCont = styled.div`
  display: flex;
  input[type='text'] {
    background: #ffffff;
    border: 1px solid #cacaca;
    outline: 0;
    width: 230px;
    padding: 10px 16px;
    border-radius: 2px;
    font-family: 'Lato';
  }
  @media (max-width: 768px) {
    input[type='text'] {
      width: 100%;
    }
  }
`;
export const BtnAddBalance = styled.button`
  display: inline-flex;
  flex: 1;
  margin-left: 20px;
  background: linear-gradient(131.54deg, #53b2fe -11.7%, #065af3 158.39%);
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  outline: 0;
  border: 0;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 900;
  color: #fff;
  font-family: 'Lato';
  @media (max-width: 768px) {
    margin-left: 0;
    height: 43px;
    display: flex;
    margin-top: 20px;
    flex: unset;
  }
`;
export const ErrMsg = styled.p`
  font-size: 12px;
  color: #ff4e56;
  margin-top: 8px;
`;
export const SuccessMsg = styled.p`
  font-size: 12px;
  color: #198b7d;
  margin-top: 8px;
  span {
    font-weight: 700;
  }
`;
export const DescriptionText = styled.p`
  font-size: 12px;
  color: #4a4a4a;
  line-height: 16px;
  margin-top: 10px;
  a {
    color: #008cff;
    cursor: pointer;
  }
`;
